import { IHisInfoItemBehavior } from "./IHisInfoItemBehavior";
import { HisInformationItem } from "../..";
import { StringUtility } from "../../../system/StringUtility";
import { IHisInformationValue, HisInformationTextValue } from "../../HisInformationValue";
import { PtKanaHiraganaBehavior } from "./PtKanaHiraganaBehavior";

/** HIS項目患者ふりがな・名を生成する */
export class PtKanaHiraganaMeiBehavior implements IHisInfoItemBehavior {
  private static readonly Key = "PT_KANA_HIRAGANA_MEI";
  
  getValue(hisInfoItems: HisInformationItem[]): IHisInformationValue {
    const itemValues =  hisInfoItems.filter(x => x.name === PtKanaHiraganaMeiBehavior.Key).map(x => x.value);
    const behavior = new PtKanaHiraganaBehavior();
    const values = behavior.getValue(hisInfoItems).data as string[];
    const mei = values.map(x => StringUtility.getTextAfterSpace(x));
    const data = itemValues.length > 0 ? itemValues : mei;
    return new HisInformationTextValue(PtKanaHiraganaMeiBehavior.Key, data);
  }
}
